/**
 * TealerLab — Header actions behaviour (3 cards: Weedélité / Mon compte / Mon pochon)
 * + Loyoly points sync.
 *
 * The markup is server-rendered by snippets/tlr-header-stack.liquid: this file
 * builds no DOM, it only binds behaviour on the stack that is already there.
 * Nothing runs when the stack is absent (all three blocks disabled in settings).
 */
(function () {
  'use strict';

  // ── Header actions: comportements du stack rendu côté serveur
  function initHeaderStack() {
    function bind() {
      var stack = document.querySelector('header-component .tlr-hdr-stack');
      if (!stack) return;

      // Clic "Mon pochon" : l'ancre porte data-tlr-cart-open — le drawer l'ouvre
      // par délégation document (tlr-cart-drawer.js), re-render de section compris.

      // Auto-open quand un produit est ajouté — attend la fin de l'anim fly-to-cart
      var _tlrPendingOpen = false;
      function _tlrOpenAfterFly() {
        if (_tlrPendingOpen) return;
        _tlrPendingOpen = true;
        var open = function () {
          _tlrPendingOpen = false;
          if (window.tlrOpenCart) window.tlrOpenCart();
        };
        if (window._tlrFlyAnimating) {
          var onComplete = function () {
            document.removeEventListener('tlr:fly:complete', onComplete);
            setTimeout(open, 180);
          };
          document.addEventListener('tlr:fly:complete', onComplete);
          setTimeout(function () {
            if (_tlrPendingOpen) {
              document.removeEventListener('tlr:fly:complete', onComplete);
              open();
            }
          }, 1500);
        } else {
          setTimeout(open, 80);
        }
      }
      document.addEventListener('cart:updated', _tlrOpenAfterFly);

      // Click outside pour fermer le drawer
      function setupCloseOnOutside() {
        var dialog = document.querySelector('dialog.cart-drawer__dialog, cart-drawer-component dialog, dialog#cart-drawer');
        if (!dialog || dialog._tlrCloseBound) return;
        dialog._tlrCloseBound = true;
        dialog.addEventListener('click', function (e) {
          var rect = dialog.getBoundingClientRect();
          var clickedInside = e.clientX >= rect.left && e.clientX <= rect.right &&
                              e.clientY >= rect.top && e.clientY <= rect.bottom;
          if (!clickedInside) {
            try { dialog.close(); } catch (_) {}
          }
        });
      }
      setupCloseOnOutside();
      new MutationObserver(setupCloseOnOutside).observe(document.body, { childList: true, subtree: false });

      // Mon compte → trigger shopify-account natif si dispo. Délégation document :
      // survit aux re-rendus de section (le bloc s'identifie par data-tlr-hdr,
      // pas par son libellé, éditable au customizer).
      document.addEventListener('click', function (e) {
        if (!e.target.closest('.tlr-hdr-block[data-tlr-hdr="account"]')) return;
        var nativeAcc = document.querySelector('shopify-account button, shopify-account a, .account-button button');
        if (nativeAcc) { e.preventDefault(); nativeAcc.click(); }
      });

      // Pas de fetch au chargement : le badge est rendu depuis cart.item_count.
      document.addEventListener('cart:updated', updateCartCount);
    }

    function updateCartCount() {
      fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) {
        var badge = document.querySelector('.tlr-hdr-block--cart [data-cart-count]');
        if (!badge) return;
        var n = c.item_count || 0;
        badge.textContent = n;
        // Empty cart → no badge at all (it used to show a red "0" on load)
        badge.hidden = n === 0;
      }).catch(function () {});
    }

    if (document.readyState !== 'loading') bind();
    else document.addEventListener('DOMContentLoaded', bind);
  }

  // ── LOYOLY POINTS — remplace "Programme fidélité" par le solde réel du client
  function initLoyoltyPoints() {
    function applyPoints(pts) {
      var el = document.querySelector('[data-tlr-loy-sub]');
      if (!el) return;
      var n = parseInt(pts, 10);
      if (isNaN(n) || n < 0) return;
      el.textContent = n.toLocaleString('fr-FR') + ' pts';
    }

    function readPointsFromDOM() {
      var items = document.querySelectorAll('.lds-widget-profile-details-item');
      for (var i = 0; i < items.length; i++) {
        var label = items[i].querySelector('[class*="typography-small"]');
        if (label && label.textContent && label.textContent.trim().toLowerCase() === 'points') {
          var valEl = items[i].querySelector('[class*="typography-h2"]');
          var val = valEl && valEl.textContent && valEl.textContent.trim();
          if (val && !isNaN(parseInt(val, 10))) return parseInt(val, 10);
        }
      }
      return null;
    }

    function init() {
      if (!window.loyoly_customer_id) return;
      var pts = readPointsFromDOM();
      if (pts !== null) { applyPoints(pts); return; }
      var target = document.getElementById('loyoly-widget') || document.body;
      var obs = new MutationObserver(function () {
        var p = readPointsFromDOM();
        if (p !== null) { obs.disconnect(); applyPoints(p); }
      });
      obs.observe(target, { childList: true, subtree: true });
      setTimeout(function () { obs.disconnect(); }, 12000);
    }

    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init, { once: true });
  }

  initHeaderStack();
  initLoyoltyPoints();
})();
